
    import Vue from "vue";
    import { Prop, Watch, Component } from "vue-property-decorator";
import { Marca } from '@/__env/lib/Articulos/Marcas';
import { Wait } from '@/__env/ext';

    @Component( {
        name: "Componente",
        props: {},
        components: {}
    } )
    export default class Componente extends Vue
    {


        @Prop( { type: Boolean } ) public disabled: boolean;
        @Prop( { type: Boolean } ) public readonly: boolean;

        @Prop( { type: Marca } )
        public value: Marca;

        @Watch( 'value', { immediate: true } )
        onIndex()
        {
            this.Selected = this.value;
        }

        constructor()
        {
            super();
        }

        public Items: Marca[] = [];

        public Busqueda: string = '';
        @Watch( 'Busqueda' )
        public async Buscar()
        {

            if ( this.Estado === 'cargando' )
                return;

            let bb = this.Busqueda;
            await Wait( 600 );
            if ( bb == this.Busqueda )
            {
                this.Estado = 'cargando';
                let e = await Marca.find( { q: this.Busqueda } );
                this.Items = e.Items;
                this.Estado = 'ok';
            }
 
        }




        public selected: Marca | null = null;
        public get Selected(): Marca | null
        {
            return this.selected;
        }
        public set Selected( x: Marca | null )
        {
            this.selected = x;
            this.$emit( 'input', this.Selected );
        }

        public async onLostFocus( event: any )
        {

        }

        public Estado: 'cargando' | 'ok' | 'error' | 'vacio' | 'iniciado' = 'iniciado';
    }
